import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/simple-vs-compound-interest',
  component: () => import('../../routes/SimpleVsCompoundInterest.svelte'),
  card: {
    id: 'simple-vs-compound-interest',
    title: 'Simple vs Compound Interest',
    description: 'Compare simple interest vs compound interest side-by-side to see the power of compounding.',
    icon: 'compare',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/simple-vs-compound-interest',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Simple vs Compound Interest Calculator – Compare Growth Side-by-Side',
    description: 'Compare simple interest and compound interest to see how compounding accelerates your investment growth. Supports daily, monthly, quarterly, and annual compounding frequencies.',
  },
};

export default meta;
